<template>
  <div>
    <v-layout row wrap>
      <v-flex md12>
        <h2>Lunar Calendar Conversion Test Page</h2>
        <v-card>
          <v-card-text>
            <v-container grid-list-sm class="pa-4">
              <v-layout row wrap>
                <v-flex md4 xs12 align-left justify-space-between>
                  <h3>Gregorian Input</h3>
                  <br />
                  <v-menu
                    v-model="menuDateStart"
                  >
                    <v-text-field
                      v-model="date"
                      slot="activator"
                      label="Select Gregorian Date"
                      readonly
                    />
                    <v-date-picker v-model="date" reactive />
                  </v-menu>
                  <v-text-field
                    label="Number of days to deduct"
                    value="7 days"
                    v-model="days"
                    type="text"
                  />
                  <br />
                  <v-btn color="primary" @click.stop="calc">Calculate Lunar Date</v-btn>
                </v-flex>
                <v-flex md4 offset-md1 xs12 align-left justify-space-between>
                  <h3>Lunar Result</h3>
                  <br />
                  <v-text-field
                    v-if="resultsLoaded"
                    label="Lunar date"
                    v-model="lunarStartDate"
                    type="text"
                    disabled
                  />
                  <v-text-field
                    v-if="resultsLoaded"
                    :label="`Lunar date minus ${days}`"
                    value="7 days"
                    v-model="lunarFinalDate"
                    type="text"
                    disabled
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script type="text/javascript">
  export default {
    data () {
      return {
        menuDateStart: false,
        date: this.moment().format('YYYY-MM-DD'),
        days: '7 days',
        lunarStartDate: null,
        lunarFinalDate: null,
        resultsLoaded: false
      }
    },
    watch: {
      date (newValue) {
        this.resultsLoaded = false
      }
    },
    methods: {
      async calc () {
        const apiUrl = this.$store.getters.config.api_host
        const data = {
          date: this.date,
          days: this.days
        }
        const response = await this.$axios.post(`${apiUrl}/api/test_lunar`, data)
        if (response) {
          this.resultsLoaded = true
          this.lunarStartDate = `${response.data.additional_data[0].lunarYear}-${response.data.additional_data[0].lunarMonth}-${response.data.additional_data[0].lunarDay}`
          this.lunarFinalDate = `${response.data.additional_data[1][0]}-${response.data.additional_data[1][1]}-${response.data.additional_data[1][2]}`
        }
      }
    }
  }
</script>

<style scoped>
  h2 {
    text-transform: uppercase;
    font-weight: normal;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
    padding-bottom: 10px;
    position: relative;
    font-size: 18px;
  }
  h2:after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background: #fff;
    position: absolute;
    bottom: -2px;
  }
</style>



// WEBPACK FOOTER //
// TestCalendar.vue?dd81f816